import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-report-diversity',
  templateUrl: './report-diversity.component.html',
  styleUrls: ['./report-diversity.component.scss']
})
export class ReportDiversityComponent implements OnInit {

  constructor(
    private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService, private router: Router,
    private filterDataHandlerService: FilterDataHandlerService, 
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private hashService: HashService
  , private talentInsightsService: TalentInsightsService) { }
  companyDetails: any;
  currentCompanyName: string;
  genderChart: any = [];
  totalFunctionResultCount: number = 0;
  dropDownMenu: any = [];
  selectedIndustries: any;
  genderChartByIndustries: any;
  startIndexForDiversity: number = 0;
  previousDiversityData: any = [];
  previousDiverityFunctions: any[] = [];
  diversityTable: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['key', 'doc_count', 'male', 'graph', 'female'];
  aggregatescount: number = 50;
  isViewMore: boolean = true;

  showGenderDropdownChartLoader: Boolean = true;
  showGenderChartLoader: Boolean = true;
  showTitlestLoader: Boolean = true;
  jobTitleData: any[] = []
  totalResultCount: any;
  diversityJobTitles: any[] = []
  pagination: boolean = true;
  pageSize = 10;
  start: number = 0;
  end: number = 10;
  currentPage = 1;
  totalCountPage = 0;
  talentfilterdata:any = {};
  totalCount:number = 0;
  jobtitlearray: any[]=[];
  jobtitles: any
  @ViewChild('titlesort') titlesort: MatSort;
  isApiCalled: boolean = false;
  diversitysubscription: Subscription;
  insightsExportSubscription: Subscription = null;
  subscriptions: Array<Subscription> = [];

  /**Sorted data collection of shown pages */
  diversitySortData: any = [];
  jobTitleKey: any;
  diversitydataAI: any;
  get isLocationEurope() {
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  ngOnInit(): void {
    // const diversitysubscription = this.personSearchService.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(diversitysubscription);

    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) { 
      this.talentfilterdata = talentFilterData 
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.getGenderChart();
    this.getDropDownMenu();
    this.getJobTitles();
    this.personSearchService.setTalentinsightsFilterAI(this.talentfilterdata);

  }

  getGenderChart() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    
    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.showGenderChartLoader = false;
      this.totalFunctionResultCount = response.data.aggregations.gender[0]?.doc_count + response.data.aggregations.gender[1]?.doc_count;
      const data = response.data.aggregations.gender;
      const CharForSeniority = [];

      data && data.forEach(x => {
        let dataObj = {
          label: `${x.key == 'male' ? 'Men' : 'Women'}`,
          value: x.doc_count,
          tooltext: `$label <br> Talent Count: $dataValue`
        }
        CharForSeniority.push(dataObj)
      })


      this.genderChart = {
        "type": "doughnut2d",
        "dataFormat": "json",
        "chart": {
          "paletteColors": " #95e1d3, #ffd3a3, #1B4E6B, #3934a5",
          "use3DLighting": "0",
          "decimals": "0",
          "yAxisNameFontColor": '#2C2C2C',
          "animateClockwise": "1",
          legendPosition: "bottom",
          "legendAllowDrag": "0",
          "theme": "fusion",
          legendWidth: "500",
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          legendItemFont: "Poppins"
        },
        "data": CharForSeniority
      }
    });
  }


  getDropDownMenu() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_industry';
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      this.showGenderDropdownChartLoader=false;
      this.dropDownMenu = response.data.aggregations[aggReq.aggregatetype].length > 0 ? response.data.aggregations[aggReq.aggregatetype].map(x => x.key):[];
      const filterSelectedPsuedoEvent = {
        target: {
          value : ""
        }
      };
      if (aggReq?.industries?.length) {
        filterSelectedPsuedoEvent.target.value = aggReq.industries[0];
      }
      this.filterselected(filterSelectedPsuedoEvent);
    });
  }

  filterselected(event) {
    if( event.target.value == "null" || event.target.value == "undefined" || event.target.value == "All" || event.target.value == ""){
      this.selectedIndustries = null;
    } else {
      this.selectedIndustries = event.target.value;
    }
    this.getGenderChartByIndustries();
  }

  getGenderChartByIndustries() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    if (!!this.selectedIndustries) {
      aggReq.industries = [this.selectedIndustries];
    }
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
     
      const male = response.data.aggregations.gender[0]?response.data.aggregations.gender[0]:0
      const female = response.data.aggregations.gender[1]?response.data.aggregations.gender[1]:0
      this.totalFunctionResultCount = male+female;
      const data = response.data.aggregations.gender;
      const ChartForGender = [];

      data && data.forEach(x => {
        let dataObj = {
          label: `${x.key == 'male' ? 'Men' : 'Women'}`,
          value: x.doc_count,
          tooltext: `$label <br> Talent Count: $dataValue`
        }
        ChartForGender.push(dataObj)
      })

      this.genderChartByIndustries = {
        "type": "doughnut2d",
        "dataFormat": "json",
        "chart": {
          "paletteColors": "#95e1d3, #ffd3a3, #1B4E6B",
          "use3DLighting": "0",
          "decimals": "0",
          "yAxisNameFontColor": '#2C2C2C',
          "animateClockwise": "1",
          legendPosition: "bottom",
          "legendAllowDrag": "0",
          "theme": "fusion",
          legendWidth: "500",
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          legendItemFont: "Poppins"
        },
        "data": ChartForGender
      }
    });
  }


  getJobTitles(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {
      if(response && response.data && response.data.aggregations && response.data.aggregations.current_jobtitle){
        this.isApiCalled = true;

        this.totalResultCount = response.data.totalresultscount;

        const tempData = response.data.aggregations.current_jobtitle;
        this.diversitySortData = tempData;
        this.jobTitleKey = _.pluck(tempData, 'key')
        this.totalCount = tempData.length;
        this.jobTitleData = tempData.slice(this.start, this.end);
        this.jobtitles = new MatTableDataSource(this.jobTitleData);
        this.jobtitles.sort = this.titlesort;
        this.getGenderRatio();
        this.manualSort();
        this.getdiversitydataai(tempData);
      }
    })
  }

  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if (this.aggregatescount / this.pageSize <= index) {
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getJobTitles();
    }
    else {
      this.manualSort();
    }
  }


  // TODO : Need to confirm how we can handle the aggregate type for this method.
  getGenderRatio(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_jobtitle-gender";
    aggReq.startindex = 0;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq).subscribe((response) => {

      if (response && response.data && response.data.aggregations && response.data.aggregations['current_jobtitle-gender']) {
        const tempData = response.data.aggregations['current_jobtitle-gender'];

        this.diversitySortData.map(res => {
          const gender = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
          if (gender && gender.gender && gender.gender.length > 0) {
            const femalecount = gender.gender.filter(x => x.key == "female") && gender.gender.filter(x => x.key == "female").length > 0 ? gender.gender.filter(x => x.key == "female")[0].doc_count : 0;
            const malecount = gender.gender.filter(x => x.key == "male") && gender.gender.filter(x => x.key == "male").length > 0 ? gender.gender.filter(x => x.key == "male")[0].doc_count : 0;
            const totalgendercount = femalecount + malecount
            res.female = femalecount ? this.getdiversitypercentage(femalecount, totalgendercount) : 0

            res.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount) : 0;
          }
          return res;
        })
        this.getdiversitydataai(this.diversitySortData);
      }
    })
  }

  getdiversitypercentage(value, doc_count) {
    return ((value / doc_count) * 100).toFixed(2);
  }

  maleDataPercent(gender) {
    if (gender[0]?.key == "male") {
      let totalGender = 0
      gender.map((res) => {
        totalGender = totalGender + res.doc_count;
      })
      const percent = (gender[0].doc_count * 100) / totalGender;
      return percent ? percent.toFixed(0) : 0;
    } else {
      return 0;
    }


  }

  femaleDataPercent(gender) {
    if (gender[1]?.key == "female") {
      let totalGender = 0
      gender.map((res) => {
        totalGender = totalGender + res.doc_count;
      })
      const percent = (gender[1].doc_count * 100) / totalGender
      return percent ? percent.toFixed(0) : 0;
    } else {
      return 0;
    }
  }

  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  manualSort() {
    this.reSortArr(this.titlesort);
  }

  reSortArr(sort: MatSort) {
    const data = this.diversitySortData;

    if (!sort || !sort.active || sort.direction === '') {
      this.jobTitleData = data.slice(this.start, this.end);
      this.jobtitles = new MatTableDataSource(this.jobTitleData);
      this.jobtitles.sort = this.titlesort;
      return;
    }
    this.diversitySortData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'male': return this.compare(a.male, b.male, isAsc);
        case 'female': return this.compare(a.female, b.female, isAsc);
        default: return 0;
      }
    });

    this.jobTitleData = this.diversitySortData.slice(this.start, this.end);
    this.jobtitles = new MatTableDataSource(this.jobTitleData);
    this.jobtitles.sort = this.titlesort;
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
  * Handel Redirection to person search listing
  * @param type
  * @param key
  */
  handelRedirection(type: string, key: string) {
    if (this.isLocationEurope) return;

    const additionalFilters = {};
    switch (type) {
      case 'jobtitle': additionalFilters['mandatoryjobtitles'] = [key]; break;
    }

    this.talentfilterdata['additionalFilters'] = additionalFilters;
    // this.localstorageservice.setItem('talentfilters', JSON.stringify(this.talentfilterdata));
    // this.personSearchService.setTalentinsights(this.talentfilterdata);
    // this.router.navigate(['/person/search/listing'], { queryParams: { 'redirectSource': 'talent-insights' } })
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCurrentRedirection(uniqueHash, this.talentfilterdata);
    const aggReq = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=talent-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${uniqueHash}&keyword=${aggReq.booleanquery!= '*' ? aggReq.booleanquery: ''}`; 
    window.open(url, "_blank");
  }

  getdiversitydataai(data) {
    let diversitydata: any;
    diversitydata = data.map(x => {
      let res: any = {};
      res['Titles'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['Men'] = x.male+'%';
      res['Women'] = x.female+'%';
      return res;
    })
    this.diversitydataAI = {
      functions: diversitydata
    }
  }

  /**
   * Convert to titlecase
   * @param stringName 
   */
  convertToTitleCase(stringName){
    stringName = stringName.toLowerCase().split(' ');
    for(let i = 0;i<stringName.length;i++){
      stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
    }
    return stringName.join(' ');
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {    
    if(requestData?.data?.currentTab !== 'diversity') return;

    // gender chart config
    const genderChart = { renderAt: 'genderDiversityChart', type: 'column2d', dataSource: { ...this.genderChart } };
    genderChart['type'] = genderChart['dataSource']['type'];
    delete genderChart['dataSource']['type'];
    delete genderChart['dataSource']['width'];
    delete genderChart['dataSource']['chart']['width'];
    delete genderChart['dataSource']['height'];
    delete genderChart['dataSource']['chart']['height'];
    delete genderChart['dataSource']['chart']['renderAt'];

    // gender by industry chart config
    const genderByIndustriesChart = { renderAt: 'genderDiversityByIndustryChart', dataSource: { ...this.genderChartByIndustries } };
    genderByIndustriesChart['type'] = genderByIndustriesChart['dataSource']['type'];
    delete genderByIndustriesChart['dataSource']['type'];
    delete genderByIndustriesChart['dataSource']['width'];
    delete genderByIndustriesChart['dataSource']['chart']['width'];
    delete genderByIndustriesChart['dataSource']['height'];
    delete genderByIndustriesChart['dataSource']['chart']['height'];
    genderByIndustriesChart['dataSource']['chart']['legendPosition'] = 'bottom';

    const payloadForInsightsExport = {
      tab: 'diversity',
      totalresultcount: this.totalResultCount,
      chartdetails: [genderChart, genderByIndustriesChart],
      selectedIndustry: this.convertToTitleCase(this.selectedIndustries || ''),
      diversityByTitles: this.diversitySortData
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
